import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="pt-6 pb-4 px-4 sm:px-6 bg-white text-center border-b-4 border-brand-beige" data-id="element-88" data-mp="ej4mbu3165dv">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-gold/10 border border-brand-gold/30 text-brand-taupe font-bold text-xs sm:text-sm mb-2 shadow-sm" data-id="element-89" data-mp="9ll8gva8vumg">
        <span data-id="element-90" data-mp="128frdnreylxt">✨</span>
        <span className="tracking-wide" data-id="element-91" data-mp="128yye9fizpx2">VALIDATED TEACHING METHOD</span>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-brand-taupe leading-none mb-2" data-id="element-92" data-mp="xbfht2vcv11y">
        The Complete Planning System for Dance Instructors
      </h1>

      <p className="text-base sm:text-lg text-brand-taupe/90 font-semibold leading-tight mb-4 max-w-2xl mx-auto" data-id="element-93" data-mp="nczr3108ptsz">
        Save time, reclaim your creativity, and elevate your teaching — without
        the exhaustion of manual planning.
      </p>

      <div className="inline-block bg-brand-rose text-white px-4 py-1 rounded-md mb-2 shadow-md" data-id="element-94" data-mp="384jsewrv5frv">
        <p className="font-button font-bold text-sm sm:text-base tracking-wide" data-id="element-95" data-mp="3j6fxtot8hbdb">
          Dance Ready 6-in-1 Box Set
        </p>
      </div>

      <div className="mb-4" data-id="element-96" data-mp="39aur5dd7zmx8">
        <a href="#pricing" className="block cursor-pointer" data-id="element-97" data-mp="399jnddjryf64">
          <img src="https://cdn.magicpatterns.com/uploads/vNhitVHkq5bJ6yeknhzbRq/ChatGPT-Image-14-jun-2026_-10_23_58-p.m..webp" alt="Dance Ready 6-in-1 Box Set" className="w-full h-auto object-contain max-w-[280px] sm:max-w-sm mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-xl" data-id="element-98" data-mp="3e8wl4tc6p6nh" />
        </a>
      </div>

      <div className="mb-3" data-id="element-99" data-mp="2qi0lxb5ef967">
        <CTAButton data-id="element-100" data-mp="2vievixmner6c">🚀 YES, I WANT MY SYSTEM NOW</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-4 text-xs sm:text-sm text-brand-taupe font-bold" data-id="element-101" data-mp="2vglq1lnruczx">
        <div className="flex items-center gap-1" data-id="element-102" data-mp="2ljpbay7a4umx">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-103" data-mp="2lmlaepuv5pcy" />
          <span data-id="element-104" data-mp="s3mcu1g2bwxu">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1" data-id="element-105" data-mp="nb1imyt8vhts">
          <Shield className="w-4 h-4 text-brand-rose" data-id="element-106" data-mp="n98g9vpnzjrl" />
          <span data-id="element-107" data-mp="id9tudnwcbtt">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}